import React from "react";
import { BookOpenIcon } from "lucide-react";
type MockupSlotProps = {
  src?: string;
  label: string;
  hint?: string;
  className?: string;
};
export function MockupSlot({
  src,
  label,
  hint = "Visuel réel bientôt disponible",
  className = ""
}: MockupSlotProps) {
  if (src) {
    return <div className={`overflow-hidden rounded-2xl bg-cream ${className}`} data-id="element-157" data-mp="3hwaj2soky46c">
        <img src={src} alt={label} className="h-full w-full object-cover" data-id="element-158" data-mp="9hjr4f43mj21" />
      </div>;
  }
  return <div role="img" aria-label={`${label} — visuel à venir`} className={`flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-tangerine/40 bg-sun-light/70 p-4 text-center ${className}`} data-id="element-159" data-mp="egwo3soop6ic">
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white" data-id="element-160" data-mp="4gci6cq7zdts">
        <BookOpenIcon className="h-5 w-5 text-tangerine" aria-hidden="true" data-id="element-161" data-mp="2k7s0obtgpsza" />
      </span>
      <p className="font-display text-sm font-bold leading-tight text-royal md:text-base" data-id="element-162" data-mp="2p97mw77dm5j9">
        {label}
      </p>
      <p className="text-xs font-semibold text-cocoa-soft" data-id="element-163" data-mp="3jjbwpydkcu0n">{hint}</p>
    </div>;
}